import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  ActionSheetController,
  MenuController,
  IonicModule,
} from '@ionic/angular';
import { VisorgisService } from '../../services/visorgis.service';
import { AuthService } from '../../../login/services/auth.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-card-right',
  templateUrl: './card-right.component.html',
  styleUrls: ['./card-right.component.css'],
  encapsulation: ViewEncapsulation.None,
  imports: [IonicModule, FormsModule],
})
export class CardRightComponent implements OnInit, AfterViewInit {
  @Output() onCloseMenu: EventEmitter<any> = new EventEmitter();
  @Output() onToggleOption: EventEmitter<any> = new EventEmitter();
  searcher = '';
  menuType = 'overlay';
  result: string;
  num_socio = -1;

  constructor(
    private menu: MenuController,
    private router: Router,
    private service: VisorgisService,
    private actionSheetCtrl: ActionSheetController,
    private authService: AuthService
  ) {}

  get depositos() {
    return this.service.depositos.getValue();
  }

  set depositos(value) {
    this.service.depositos.next(value);
  }

  get pozos() {
    return this.service.pozos.getValue();
  }

  set pozos(value) {
    this.service.pozos.next(value);
  }

  get cabezales() {
    return this.service.cabezales.getValue();
  }

  set cabezales(value) {
    this.service.cabezales.next(value);
  }

  get hidrantes() {
    return this.service.hidrantes.getValue();
  }
  set hidrantes(value) {
    this.service.hidrantes.next(value);
  }
  get red() {
    return this.service.red.getValue();
  }
  set red(value) {
    this.service.red.next(value);
  }
  get impulsion() {
    return this.service.impulsion.getValue();
  }
  set impulsion(value) {
    this.service.impulsion.next(value);
  }
  get parcelas() {
    return this.service.parcelas.getValue();
  }
  set parcelas(value) {
    this.service.parcelas.next(value);
  }
  get tomas() {
    return this.service.tomas.getValue();
  }
  set tomas(value) {
    this.service.tomas.next(value);
  }

  get balsas() {
    return this.service.balsas.getValue();
  }
  set balsas(value) {
    this.service.balsas.next(value);
  }

  get tuberias() {
    return this.service.tuberias.getValue();
  }
  set tuberias(value) {
    this.service.tuberias.next(value);
  }

  get parcelas_comunero() {
    return this.service.parcelas_comunero.getValue();
  }
  set parcelas_comunero(value) {
    this.service.parcelas_comunero.next(value);
  }

  get estaciones() {
    return this.service.estaciones.getValue();
  }
  set estaciones(value) {
    this.service.estaciones.next(value);
  }

  get listadoParcelas() {
    return this.service.listadoElementos;
  }

  ngOnInit(): void {
    const user = this.authService.getUserLogin();
    this.num_socio = user?.num_socio || -1;
  }

  ngAfterViewInit() {
    this.menu.enable(true, 'right-menu');
  }

  onCloseMenuDerecho() {
    this.onCloseMenu.emit(true);
  }

  onClick() {
    console.log('click');
  }

  toggle() {
    this.menu.toggle('right-menu').then(res => console.log(res));
  }

  goToHome() {
    this.router.navigateByUrl('/home');
  }

  onSearchEvent(event) {}

  async presentActionSheet() {
    this.service.presentActionSheet();
  }
}
